import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab, Typography, Paper } from "@mui/material";
import { Link } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Button, Card, Container, Col, Row} from 'react-bootstrap';
import { InputField } from '../../components/Common/FormikField/InputField';
import { email_required, string_required, GetSchema } from '../../js/Base/ValidationSchema';
import toastAlert from '../../js/Base/ToastAlert';
import Image from 'react-bootstrap/Image';
import { getCaptcha } from '../../api/authApi';

export default function ForgetPwd() {
  const [captchaUrl, setCaptchaUrl] = useState(null);

  const initialValues = {
    email: '',
    captcha: '',
  };
  const formSchema = GetSchema({
    email: email_required(),
    captcha: string_required(),
  });

  const fetchCaptcha = async () => {
    try {
      const blob = await getCaptcha();
      const url = URL.createObjectURL(blob);
      setCaptchaUrl(url);
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError('取得驗證碼錯誤');
    }
  };

  useEffect(() => {
    fetchCaptcha();
  }, []);

  // 忘記密碼(無法使用api.post因為是不同個 session取不到captcha)
  const handleSubmit = async (values, { setSubmitting, resetForm, setErrors }) => {
    try {
      const response = await fetch('/api/create_forget_pwd_captcha/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      });

      const data = await response.json();
      if (data.success) {
        toastAlert.autoClose(true).showSuccess('密碼重設信已寄出，請查看信箱。');
      } else {
        toastAlert.autoClose(true).showError('發生錯誤，請稍後再試');
      }
      setTimeout(() => {
        document.location.assign(document.location.origin + '/');
      }, 5000);
    } catch (error) {
      resetForm();
      fetchCaptcha();
      toastAlert.autoClose(true).showError('發生錯誤，請稍後再試');
    } finally {
      setSubmitting(false);
    }
  };

  const input_style = {
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    paddingLeft: '0px',
    borderRadius: '0px',
    marginTop: '30px',
    fontWeight: 'bold',
    fontSize: '14px',
  };

  const removeMenuLogHandler = () => {
    // dispatch(loginMenuAction.removeAllMenu());
  };

  return (
    <div className="LoginManagement">
      <div
        className="banner-1 login-page"
        style={{
          backgroundImage: `url(/assets/images/bg_login@2x.png)`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          color: '#ffffff',
          padding: '0px',
        }}
      >
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "transparent",
            p: 2,
          }}
        >
          <Link
            to="/"
            className="logo ms-4"
            onClick={() => {
              removeMenuLogHandler();
            }}
          >
            <Image alt="Cloudgoda" src="/assets/images/logo_deep_login_pg@2x.png" rounded style={{ width: '150px', height: 'auto' }}/>
          </Link>
          <Paper elevation={3} sx={{ width: "100%", maxWidth: 400, p: 3 }}>
            <p className="paper-title">重設密碼</p>
            <p className="paper-desc">若要重設密碼，請輸入您註冊帳號的電子郵件地址。您將會在隨後收到電子郵件，內含重設密碼的相關指示。</p>
            <div>
              <Formik
                initialValues={initialValues}
                validationSchema={formSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting, errors, touched }) => (
                  <Form>
                    <InputField
                      id="email"
                      className="input-field"
                      maxLength="50"
                      inputName="email"
                      placeholder="會員帳號"
                      user-account
                      style={input_style}
                      isInvalid={errors.user_email && touched.user_email}
                    />
                    <div className="form-row">
                      <div className="captcha-row">
                        <InputField
                          id="captcha"
                          className="input-field"
                          maxLength="6"
                          inputName="captcha"
                          placeholder="驗證碼"
                          style={input_style}
                          showError={false}
                          isInvalid={errors.captcha_url && touched.captcha_url}
                        />
                        <img
                          src={captchaUrl}
                          alt="驗證碼"
                          className="captcha-img"
                          onClick={fetchCaptcha}
                        />
                      </div>
                      <ErrorMessage name="captcha">
                        {(msg) => <span className="text-danger" style={{ fontSize: "14px" }}>{msg}</span>}
                      </ErrorMessage>
                    </div>

                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="btn-login btn-custom"
                      style={{ height: "36px" }}
                    >
                      {isSubmitting? "請稍後..." : "重設密碼"}
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </Paper>
        </Box>
      </div>
    </div>
  )
}
